import React from 'react';
import { motion } from 'framer-motion';
import type { FiltekProduct } from '../../types/filtek';
interface ProductGlyphProps {
  form: FiltekProduct['form'];
  accent: string;
  className?: string;
}
const stroke = {
  stroke: 'var(--enamel)',
  strokeOpacity: 0.35,
  strokeWidth: 1.25,
  fill: 'none'
} as const;

/**
 * A drawn delivery form rather than product packaging — a syringe for the
 * sculptables, a capsule tip for bulk, and the warmer for the cousin.
 */
export function ProductGlyph({
  form,
  accent,
  className = ''
}: ProductGlyphProps) {
  if (form === 'warmer') {
    return <svg viewBox="0 0 120 240" className={className} role="img" aria-label="Composite warmer" data-id="element-424" data-mp="t89x4h2mmvm3">
        {/* syringe standing in the warmer */}
        <g {...stroke} data-id="element-425" data-mp="obb27wb52kmu">
          <rect x="52" y="22" width="14" height="30" rx="3" data-id="element-426" data-mp="o7vph04xtnol" />
          <rect x="42" y="52" width="34" height="7" rx="3" data-id="element-427" data-mp="k6tp2fzab5l1" />
          <rect x="45" y="59" width="28" height="116" rx="7" data-id="element-428" data-mp="f9a5r1nqc2m8" />
        </g>
        <motion.rect x="47.5" width="23" rx="6" fill={accent} fillOpacity="0.36" initial={{
        height: 0,
        y: 173
      }} animate={{
        height: 74,
        y: 99
      }} transition={{
        duration: 1.1,
        ease: [0.16, 1, 0.3, 1],
        delay: 0.2
      }} data-id="element-429" data-mp="fbecdrd0jfq7" />

        {/* warming base */}
        <g {...stroke} data-id="element-430" data-mp="3jtb6lns702ax">
          <rect x="16" y="174" width="88" height="50" rx="18" data-id="element-431" data-mp="3jumenzso7w7u" />
          <circle cx="88" cy="199" r="4" data-id="element-432" data-mp="be9fu34s1uc8" />
        </g>

        {[0, 1].map(index => <motion.path key={index} d={`M${32 + index * 12} 168 q7 -12 0 -24`} stroke={accent} strokeWidth="1.5" strokeLinecap="round" fill="none" animate={{
        opacity: [0.15, 0.75, 0.15],
        y: [4, -6, 4]
      }} transition={{
        duration: 3.2,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: index * 0.5
      }} data-id="element-433" data-mp="gcuehy4ds5yk" />)}
      </svg>;
  }
  const isBulk = form === 'bulk';
  return <svg viewBox="0 0 120 240" className={className} role="img" aria-label={`${form} syringe`} data-id="element-434" data-mp="xl3pzjmorg61">
      <g {...stroke} data-id="element-435" data-mp="son12n7nwxrw">
        <rect x="54" y="6" width="12" height="34" rx="3" data-id="element-436" data-mp="so3svy7tdnr2" />
        <rect x="38" y="40" width="44" height="7" rx="3" data-id="element-437" data-mp="nvtvjx4ddler" />
        <rect x="42" y="47" width="36" height={isBulk ? 108 : 116} rx="8" data-id="element-438" data-mp="nu93qf9fwgkl" />
      </g>

      <motion.rect x="44.5" width="31" rx="6" fill={accent} fillOpacity="0.34" initial={{
      height: 0,
      y: isBulk ? 155 : 163
    }} animate={{
      height: isBulk ? 74 : 82,
      y: 81
    }} transition={{
      duration: 1.1,
      ease: [0.16, 1, 0.3, 1],
      delay: 0.2
    }} data-id="element-439" data-mp="jsxlwvwt4zmy" />

      <g {...stroke} data-id="element-440" data-mp="4zkk7hkur8yg">
        {isBulk ? <>
            <path d="M46 155 h28 l-6 20 h-16 z" data-id="element-441" data-mp="xh6emapnsa0" />
            <rect x="52" y="175" width="16" height="26" rx="4" data-id="element-442" data-mp="1zbseqtt9hntp" />
          </> : <>
            <path d="M46 163 h28 l-8 16 h-12 z" data-id="element-443" data-mp="1vagjo8rmcae4" />
            <rect x="55" y="179" width="10" height="22" rx="4" data-id="element-444" data-mp="1vaovdxc099nq" />
          </>}
      </g>
    </svg>;
}